import appConfig from '@/features/app/constants/app-config';
import getRefreshTokenExpiryTime from '@/features/auth/functions/getRefreshTokenExpiryTime';
import { _clientNow } from '@/shared/functions/timezone';

export default function isRefreshTokenStillValid(
  useCookieStorage: boolean,
  enableLegacyTokenStorage: boolean,
  threshold = appConfig.refreshTokenThreshold
) {
  const expiryTime = getRefreshTokenExpiryTime(useCookieStorage, enableLegacyTokenStorage);
  if (!expiryTime) return false;
  return _clientNow().isBefore(expiryTime.subtract(threshold, 'milliseconds'));
}
